/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import {
  // TNinusiSeikyuInfoGetRes,
  TNinusiSeikyuListGetReq,
  TNinusiSeikyuListGetRes,
} from "../../../service/master/ninusiseikyu/TNinusiSeikyu"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import commonUtil from "../../../ts/util/commonUtil"
import {
  TWijmoCellTemplateContext,
  // TWijmoComboBox,
} from "../../../type/wijmoComponents"

/**
 * 荷主請求マスタ一覧
 * @returns
 */
const MasterNinusiSeikyuList = () => {
  const history = useHistory()
  const location = useLocation()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.荷主請求マスタ
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "MasterNinusiSeikyuList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TNinusiSeikyuListGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        sort_荷主コード: (i: TNinusiSeikyuListGetRes) =>
          commonUtil.createSortString(
            i.荷主コード,
            VALIDATE_CONSTANT.LENGTH.荷主コード
          ),
        sort_表紙分割コード: (i: TNinusiSeikyuListGetRes) =>
          commonUtil.createSortString(
            i.表紙分割コード,
            VALIDATE_CONSTANT.LENGTH.表紙分割コード
          ),
        表示用廃止日: (i: TNinusiSeikyuListGetRes) =>
          !wjCore.isNullOrWhiteSpace(i.廃止日 ?? "") &&
          dayjs(i.廃止日).isValid()
            ? dayjs(i.廃止日).toDate()
            : undefined,
      },

      sortDescriptions: [
        new wjCore.SortDescription("sort_荷主コード", true),
        new wjCore.SortDescription("sort_表紙分割コード", true),
      ],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TNinusiSeikyuListGetReq,
    signal?: AbortSignal
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TNinusiSeikyuListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new NinusiSeikyuService().getList(
        currentSearchCondition,
        signal
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TNinusiSeikyuListGetReq = queryString.parse(location.search)
    set荷主コード(query.荷主コード)
    set荷主名(query.荷主名)
    //queryParseは必ずstring
    const 削除済み包含フラグ = query.削除済み包含フラグ as unknown as string
    set削除済み包含フラグ(削除済み包含フラグ === "true" ? 1 : 0)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TNinusiSeikyuListGetReq => {
    return {
      荷主コード,
      荷主名,
      削除済み包含フラグ: 削除済み包含フラグ === 1,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TNinusiSeikyuListGetReq
  ) => {
    return {
      荷主CD: wjCore.isNullOrWhiteSpace(searchCondition.荷主コード ?? "")
        ? ""
        : searchCondition.荷主コード,
      荷主名: wjCore.isNullOrWhiteSpace(searchCondition.荷主名 ?? "")
        ? ""
        : searchCondition.荷主名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set荷主コード("")
    set荷主名("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [削除済み包含フラグ, set削除済み包含フラグ] = useState<number>(0)

  //#region comboboxState

  // modal
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  //#endregion

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `荷主請求マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">荷主請求マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-75rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                value={荷主コード}
                                setValue={set荷主コード}
                                maxLength={5}
                                placeholder="荷主CD"
                              />
                              <button
                                type="button"
                                className="icon-button"
                                onClick={() => {
                                  setIs荷主検索Modal(true)
                                }}>
                                <FontAwesomeIcon
                                  className="icon-button-inner"
                                  icon={faSearch}
                                />
                              </button>
                              <TextInput
                                style={{ width: "25rem" }}
                                id="荷主名"
                                name="荷主名"
                                value={荷主名}
                                setValue={set荷主名}
                                maxLength={100}
                                placeholder="荷主名"
                              />
                              <span className={"align-middle"}>
                                <CheckInput
                                  id="廃止"
                                  type={"switch"}
                                  label={"廃止した荷主請求を表示する"}
                                  setValue={(v) => set削除済み包含フラグ(v)}
                                  value={削除済み包含フラグ}
                                />
                              </span>
                            </div>
                            <Button
                              type="submit"
                              className="ms-auto"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  allowSorting: wjGrid.AllowSorting.MultiColumn,
                }}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Link
                        to={
                          util.getMenuPath(
                            メニューコード.マスタ管理.荷主請求マスタ登録
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          新規追加
                        </Button>
                      </Link>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TNinusiSeikyuListGetRes>
                    ) => {
                      // 荷主請求登録
                      const url = util.getMenuPath(
                        メニューコード.マスタ管理.荷主請求マスタ登録
                      )[1]
                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.荷主請求ID.toString()
                              )
                            )
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={80}
                  sortMemberPath="sort_荷主コード"
                  header="荷主CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主名"
                  width={300}
                  header="荷主名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主略称1"
                  width={160}
                  header="荷主略称1"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="表紙分割コード"
                  width={80}
                  sortMemberPath="sort_表紙分割コード"
                  header="表紙CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="表紙名"
                  width={150}
                  header="表紙名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求先名"
                  width={150}
                  header="請求先部署"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求先担当者"
                  width={110}
                  header="請求先担当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求担当社員氏名"
                  width={110}
                  header="請求担当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="締日区分名称1"
                  width={110}
                  header="締日区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求書作成区分名称1"
                  width={100}
                  header="請求書作成"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="郵便番号"
                  width={90}
                  header="郵便番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住所"
                  width={450}
                  header="請求先住所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={200}
                  header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="表示用廃止日"
                  width={110}
                  header="廃止日"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
        }}></NinusiSearchModal>
    </Container>
  )
}

export default MasterNinusiSeikyuList

//#region  ダミーデータ

// TODO:ダミーデータ

//#endregion
